module.exports = __webpack_public_path__ + "static/media/scenario1_preview.d3f5fde0.jpg";